<template lang="pug">
.v-lk-employees-card.lk-employees-card(
		v-if="item"
		:class="{'opened': isHistoryOpen, 'blocked': item.blocked}")
	.lk-employees-card__head
		.lk-employees-card__icon(v-if="item.image" )
			img.lk-employees-card__image(
					:src="item.image?.src"
					:alt="item.image?.alt")
		.lk-employees-card__notes
			.lk-employees-card__info(v-if="item.info" )
				.lk-employees-card__text(v-if="item.info.name") {{ item.info.name }}
				.lk-employees-card__subtitle(v-if="item.info.position") {{ item.info.position }}
			.lk-employees-card__login(v-if="item.login" )
				.lk-employees-card__title(v-if="item.variables && item.variables?.login" ) {{ item.variables?.login }}
				.lk-employees-card__text {{ item.login }}
			.lk-employees-card__actions(v-if="isXs" )
				button.lk-employees-card__button(v-for="(button, index) in item.buttons"
					:key="index"
					:class="button?.className || ''"
					:style="{display: isHistoryOpen ? 'flex' : ''}"
					:title="button?.title || ''"
					@click="buttonEvent(button.event, button.remote)")
					v-svg-icon.lk-employees-card__button-icon(v-if="button.icon"
						:icon="button.icon"
						:class="{'rotate-180' : button?.collapse && isHistoryOpen}")
		.lk-employees-card__actions(v-if="!isXs" )
			button.lk-employees-card__button(v-for="(button, index) in item.buttons"
					:key="index"
					:class="button?.className || ''"
					:style="{display: isHistoryOpen ? 'flex' : ''}"
					:title="button?.title || ''"
					@click="buttonEvent(button.event, button.remote)")
				v-svg-icon.lk-employees-card__button-icon(v-if="button.icon"
						:icon="button.icon"
						:class="{'rotate-180' : button?.collapse && isHistoryOpen}")
	transition(name="collapse")
		.lk-employees-card__body(v-if="isHistoryOpen && item.history" )
			.lk-employees-card__body-title(v-if="item.history.title" ) {{ item.history.title }}
			template(v-if="item.history.items" )
				.lk-employees-card__body-item(v-for="(item, index) in computedShowedItems" :key="index")
					.lk-employees-card__body-timing
						.lk-employees-card__body-time(v-if="item.time" ) {{ item.time }}
						.lk-employees-card__body-date(v-if="item.date" ) {{ item.date }}
					a.lk-employees-card__body-link(v-if="item.link" :href="item.link?.href || '#'") {{ `id:${item.link?.text || ''}` }}
					.lk-employees-card__body-text(v-if="item.text" ) {{ item.text }}
			.lk-employees-card__body-action(v-if="item.history.show && item.history.hide" @click="isHistoryOpenFull = !isHistoryOpenFull") {{ computedAction }}

</template>

<script>
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
const NUMBER_VISIBLE_ITEMS = 3;
export default {
	mixins: [
		isMobMixin
	],

	props: {
		item: {
			type: Object,
			default: null
		}
	},

	emits: [
		'edit', 'remove', 'block', 'unblock'
	],

	data() {
		return {
			isHistoryOpen: false,
			isHistoryOpenFull: false
		}
	},

	methods: {
		buttonEvent(event, remote = null) {
			switch (event) {
				case "show": {
					this.isHistoryOpen = !this.isHistoryOpen;
					break
				}
				case "edit": {
					this.$emit('edit', {id: this.item.id, action: event, remote: remote})
					break
				}
				case "remove": {
					this.$emit('remove', {id: this.item.id, action: event})
					break
				}
				case "block": {
					this.$emit('block', {id: this.item.id, action: event})
					break
				}
				case "unblock": {
					this.$emit('unblock', {id: this.item.id, action: event})
					break
				}
			}
		}
	},

	computed: {
		computedShowedItems() {
			if(this.item.history.items && this.item.history.items.length) {
				return this.isHistoryOpenFull ? this.item.history.items : this.item.history.items.slice(0, NUMBER_VISIBLE_ITEMS)
			}
		},

		computedAction() {
			if(this.item.history.items && this.item.history.items.length) {
				if(!this.isHistoryOpenFull) {
					if(this.item.history.items.length > NUMBER_VISIBLE_ITEMS) {
						return `${this.item.history?.show} ${this.item.history.items.length - NUMBER_VISIBLE_ITEMS}`;
					} else {
						return null;
					}
				} else {
					return this.item.history?.hide
				}
			}
		}
	}
}
</script>
